import {
    Box,
    Divider,
    Flex,
    Skeleton,
    Stack,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
// eslint-disable-next-line caspeco-react/discourage-chakra-import
import { AspectRatio } from "@chakra-ui/react";

function ExperienceCardSkeleton({ fullWidth }: { fullWidth?: boolean }) {
    return (
        <Box py={ThemeSpaceVariable.Medium}>
            <Stack spacing={ThemeSpaceVariable.Small}>
                <AspectRatio ratio={fullWidth ? 16 / 9 : 1}>
                    <Skeleton w="full" h="full" borderRadius={ThemeSpaceVariable.Small} />
                </AspectRatio>
                <Skeleton height="20px" width="70%" />
                <Skeleton height="16px" width="90%" />
            </Stack>
        </Box>
    );
}

function SectionItemSkeleton() {
    return (
        <Box>
            <Flex
                justify="space-between"
                py={ThemeSpaceVariable.Medium}
                align="center"
                gap={ThemeSpaceVariable.Small}
            >
                <Stack spacing={ThemeSpaceVariable.Small} w="full">
                    <Skeleton height="20px" width="50%" />
                    <Skeleton height="16px" width="75%" />
                </Stack>
                <Skeleton
                    height="72px"
                    width="72px"
                    minW="72px"
                    borderRadius={ThemeSpaceVariable.Small}
                />
            </Flex>
            <Divider />
        </Box>
    );
}

function ExperienceViewContentSkeleton() {
    return (
        <Stack spacing={ThemeSpaceVariable.None}>
            {/* Experience cards: two paired + one full-width */}
            <Box
                display="grid"
                gridTemplateColumns="repeat(2, 1fr)"
                columnGap={ThemeSpaceVariable.Medium}
            >
                <Box minW={0}>
                    <ExperienceCardSkeleton />
                </Box>
                <Box minW={0}>
                    <ExperienceCardSkeleton />
                </Box>
                <Box gridColumn="1 / -1" minW={0}>
                    <ExperienceCardSkeleton fullWidth />
                </Box>
            </Box>

            {/* Section items */}
            <Divider />
            <SectionItemSkeleton />
            <SectionItemSkeleton />
        </Stack>
    );
}

export { ExperienceViewContentSkeleton };
